import axios from '@/axios';

// URL and endpoint constants
const INDEX_URL = '/learning_resources';

export default {
  index(page, succ) {
    axios.get(INDEX_URL, { params: { page } })
      .then((response) => { succ(response); });
  },
};



// WEBPACK FOOTER //
// ./src/api/v1/learningResources.js